import { TypedError } from '@rehaje/errors'

import {
  FatalAssertInheritError,
  FatalAssertInstanceError,
  FatalAssertOverrideError
} from './FatalClassError'
import { FatalEvaluateError } from './FatalEvaluateError'
import {
  FatalAddEffectError,
  FatalEffectHookError
} from './FatalLifeCycleError'
import { FatalMissingContextError } from './FatalMissingContextError'
import { FatalSchemaDefinitionError } from './FatalSchemaDefinitionError'
import {
  FatalCrossStoreError,
  FatalSelfInsertError
} from './FatalTypedNodeError'
import { FatalVisitorExistedError } from './FatalVisitorExistedError'
import { LoggerDeprecatedWarning } from './LoggerDeprecatedWarning'
import { LoggerMigrationError } from './LoggerMigrationError'
import { LoggerSilentRaiseWarning } from './LoggerSilentRaiseWarning'
import {
  SchemaAsyncFunctionError,
  SchemaCustomError,
  SchemaDeprecatedWarning,
  SchemaFormatError,
  SchemaFunctionParametersError,
  SchemaGeneratorFunctionError,
  SchemaIdempotenceError,
  SchemaIntersectionInferError,
  SchemaIntersectionTypesError,
  SchemaMaximumError,
  SchemaMaxItemsError,
  SchemaMaxLengthError,
  SchemaMaxPropertiesError,
  SchemaMinimumError,
  SchemaMinItemsError,
  SchemaMinLengthError,
  SchemaMinPropertiesError,
  SchemaPatternError,
  SchemaRequiredError,
  SchemaTransformError,
  SchemaTypeError,
  SchemaUnionEmptyError,
  SchemaUnionTypesError
} from './SchemaError'

export * from './FatalClassError'
export * from './FatalEvaluateError'
export * from './FatalLifeCycleError'
export * from './FatalMissingContextError'
export * from './FatalSchemaDefinitionError'
export * from './FatalTypedNodeError'
export * from './FatalVisitorExistedError'
export * from './LoggerDeprecatedWarning'
export * from './LoggerMigrationError'
export * from './LoggerSilentRaiseWarning'
export * from './SchemaError'

export function registerErrorsSideEffect() {
  TypedError.registerErrorLocales({
    FatalAddEffectError,
    FatalAssertInheritError,
    FatalAssertInstanceError,
    FatalAssertOverrideError,
    FatalCrossStoreError,
    FatalEffectHookError,
    FatalEvaluateError,
    FatalMissingContextError,
    FatalSchemaDefinitionError,
    FatalSelfInsertError,
    FatalVisitorExistedError,
    LoggerDeprecatedWarning,
    LoggerMigrationError,
    LoggerSilentRaiseWarning,
    SchemaAsyncFunctionError,
    SchemaCustomError,
    SchemaDeprecatedWarning,
    SchemaFormatError,
    SchemaFunctionParametersError,
    SchemaGeneratorFunctionError,
    SchemaIdempotenceError,
    SchemaIntersectionInferError,
    SchemaIntersectionTypesError,
    SchemaMaximumError,
    SchemaMaxItemsError,
    SchemaMaxLengthError,
    SchemaMaxPropertiesError,
    SchemaMinimumError,
    SchemaMinItemsError,
    SchemaMinLengthError,
    SchemaMinPropertiesError,
    SchemaPatternError,
    SchemaRequiredError,
    SchemaTransformError,
    SchemaTypeError,
    SchemaUnionEmptyError,
    SchemaUnionTypesError
  })
}

registerErrorsSideEffect()
